import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import userService from '../services/userService';
import { validateImageFile } from '../utils/validators';

export const useAvatarUpload = (onSuccess) => {
  const { getAccessTokenSilently } = useAuth0();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    setUploadError(null);

    if (!file) {
      setSelectedFile(null);
      setPreviewUrl(null);
      return;
    }

    const error = validateImageFile(file);
    if (error) {
      setUploadError(error);
      event.target.value = null;
      return;
    }

    setSelectedFile(file);
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
  };

  const uploadAvatar = async () => {
    if (!selectedFile) {
      setUploadError('Please select an image first');
      return;
    }

    setUploadLoading(true);
    setUploadError(null);

    try {
      const token = await getAccessTokenSilently();
      const updatedUser = await userService.uploadAvatar(token, selectedFile);

      onSuccess(updatedUser);
      resetUpload();
    } catch (err) {
      setUploadError(err.message);
    } finally {
      setUploadLoading(false);
    }
  };

  const resetUpload = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setSelectedFile(null);
    setPreviewUrl(null);
    setUploadError(null);
  };

  return {
    selectedFile,
    previewUrl,
    uploadLoading,
    uploadError,
    handleFileSelect,
    uploadAvatar,
    resetUpload
  };
};